import { css } from '@emotion/react';
import ReactRouterLink from '../../components/ReactRouterLink';
import useMessageService from '../../services/i18n/useMessageService';
import EmailField from '../../components/EmailField';
import Button from '../../components/Button';
import { UnauthenticatedPaths } from '../../constants/Paths';
import getTargetAttribute from '../../services/getTargetAttribute';

const SelfRegistrationForm = ({
    onSubmit,
    onChange,
    email,
    error,
    buttonLabel,
    requestStateParams,
}) => {
    const [
        [
            haveAccountLabel = 'Already have an account?',
            haveAccountLink = 'Login here',
            placeholder = 'Enter Email',
        ],
    ] = useMessageService([
        'register.already_have_account',
        'register.login_here_link',
        'register.self_register_input_placeholder',
    ]);

    return (
        <>
            <EmailField
                onChange={onChange}
                value={email}
                errorMessage={error}
                placeholder={placeholder}
                onKeyUp={onSubmit}
            />
            <Button
                onClick={onSubmit}
                disabled={!email}
                data-target={getTargetAttribute('submit-button')}
            >
                {buttonLabel}
            </Button>
            <div
                css={({ linkFontSize }) => css`
                    margin-top: 1.667rem;
                    text-align: center;
                    font-size: ${linkFontSize};
                    display: flex;
                    gap: 4px;
                    align-items: center;
                    justify-content: center;
                `}
            >
                <span>{haveAccountLabel}</span>
                <ReactRouterLink
                    css={({ linkFontSize }) => {
                        return css`
                            font-size: ${linkFontSize};
                        `;
                    }}
                    to={{
                        pathname: UnauthenticatedPaths.LOGIN,
                        search: requestStateParams,
                    }}
                >
                    {haveAccountLink}
                </ReactRouterLink>
            </div>
        </>
    );
};

export default SelfRegistrationForm;
